import { createContext } from 'react';
import { User } from 'shell/models/user';
import { UserProfile, UserProfileContext } from './types';

export const initialContext = {};

export const AuthenticationContext = createContext<UserProfileContext>({
  userProfile: initialContext,
  setUserProfile: (a?: User): UserProfile => ({ ...initialContext, datiLogin: a }),
  openLoginModal: (open: boolean) => open,
});

export const ProviderAuthentication = AuthenticationContext.Provider;
